<template>
  <v-container>
    <carga-ciclo-semestre titulo="Concentrada por Docente" :datos="periodo" />

    <v-divider />

    <v-card>
      <v-row>
        <v-col cols="12" sm="4" class="font-weight-bold"
          ><p class="my-0 text-right">
            TOTAL:<br />
            CARGA DEL PERIODO:
            <u>{{ cargaTotalPorTurno.tm + cargaTotalPorTurno.tv }} hrs.</u
            ><br />CARGA ASIGNADA:
            <u>{{ cargaAsignadaPorTurno.tm + cargaAsignadaPorTurno.tv }} hrs.</u
            ><br />
            NECESIDAD:
            <u
              >{{
                cargaNecesidadPorTurno.tm + cargaNecesidadPorTurno.tv
              }}
              hrs.</u
            >
          </p></v-col
        >
        <v-col
          cols="12"
          sm="4"
          class="font-weight-bold"
          v-if="cargaTotalPorTurno.tm"
          ><p class="my-0 text-right">
            TURNO MATUTINO:<br />
            CARGA DEL PERIODO:
            <u>{{ cargaTotalPorTurno.tm }} hrs.</u><br />CARGA ASIGNADA:
            <u>{{ cargaAsignadaPorTurno.tm }} hrs.</u><br />
            NECESIDAD:
            <u>{{ cargaNecesidadPorTurno.tm }} hrs.</u>
          </p></v-col
        >
        <v-col
          cols="12"
          sm="4"
          class="font-weight-bold"
          v-if="cargaTotalPorTurno.tv"
          ><p class="my-0 text-right">
            TURNO VESPERTINO:<br />
            CARGA DEL PERIODO:
            <u>{{ cargaTotalPorTurno.tv }} hrs.</u><br />CARGA ASIGNADA:
            <u>{{ cargaAsignadaPorTurno.tv }} hrs.</u><br />
            NECESIDAD:
            <u>{{ cargaNecesidadPorTurno.tv }} hrs.</u>
          </p></v-col
        >
        <v-col cols="12" sm="4">
          <download-csv
            :data="arrayCargaDocenteCsv"
            class="v-btn primary v-btn--block text-center"
            v-if="arrayCargaDocenteCsv.length > 0"
            :name="'carga_por_docentes.csv'"
            >Archivo CSV<br />concentrado</download-csv
          >
        </v-col>
      </v-row>
    </v-card>

    <v-divider />

    <v-card v-for="docente in docentes" :key="docente.id">
      <div v-if="cargasAsignadas[docente.id]">
        <v-card-title>{{ cargasAsignadas[docente.id].nombre }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="7"
              >Número de horas en plaza:
              <strong>{{ cargasAsignadas[docente.id].plaza_horas }}</strong
              ><br />Máximo de horas frente a grupo:
              <strong>{{
                cargasAsignadas[docente.id].maximo_horas
              }}</strong></v-col
            >
            <v-col cols="5"
              >Número de grupos:
              <strong>{{ cargasAsignadas[docente.id].grupos }}</strong
              ><br />Total de horas:
              <strong>{{ cargasAsignadas[docente.id].horas }}</strong></v-col
            >
          </v-row>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Grupo</th>
                  <th class="text-left">Materia</th>
                  <th class="text-left">Horas</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(grupo, idx) in cargasAsignadas[docente.id].detalles"
                  :key="idx"
                >
                  <td>{{ grupo.grupo }}</td>
                  <td>{{ grupo.materia }}</td>
                  <td>{{ grupo.horas }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-divider />
      </div>
    </v-card>

    <loading-wait :loading="loading" />
  </v-container>
</template>

<script>
import api from "@/api";
import CargaCicloSemestre from "@/components/CargaCicloSemestre.vue";
import LoadingWait from "@/components/LoadingWait.vue";
import { gets } from "@/mixins/gets";

export default {
  name: "CargaPorDocente",

  components: { CargaCicloSemestre, LoadingWait },

  mixins: [gets],

  props: {
    periodoSeleccionado: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    periodoActual: true,
    periodo: {},
    carga: {},
    tutorias: {},
    docentes: {},
    loading: false,
  }),

  computed: {
    arrayCargaDocenteCsv() {
      let list = [];
      for (let i in this.docentes) {
        if (this.cargasAsignadas[this.docentes[i].id]) {
          let cargasAsignadas = this.cargasAsignadas[this.docentes[i].id]
            .detalles;
          let apellidos = this.docentes[i].apellidos;
          let nombre = this.docentes[i].nombre;
          let materia = "X";
          let semestre = "";
          let grupos = "";
          let horas = "";
          for (let j in cargasAsignadas) {
            if (cargasAsignadas[j].materia != "TUTORÍA") {
              if (materia == "X") {
                materia = cargasAsignadas[j].materia;
                semestre = cargasAsignadas[j].grupo.slice(0, 1);
                grupos = cargasAsignadas[j].grupo;
                horas = cargasAsignadas[j].horas;
              } else if (materia == cargasAsignadas[j].materia) {
                grupos += "," + cargasAsignadas[j].grupo;
              } else {
                list.push({
                  Apellidos: apellidos,
                  Nombre: nombre,
                  Materia: materia.toUpperCase(),
                  Semestre: semestre,
                  Grupos: grupos,
                  Horas: horas,
                  F: "",
                });
                materia = cargasAsignadas[j].materia;
                semestre = cargasAsignadas[j].grupo.slice(0, 1);
                grupos = cargasAsignadas[j].grupo;
                horas = cargasAsignadas[j].horas;
              }
            }
          }
          list.push({
            Apellidos: apellidos,
            Nombre: nombre,
            Materia: materia.toUpperCase(),
            Semestre: semestre,
            Grupos: grupos,
            Horas: horas,
            F: "",
          });
          list.push({
            Apellidos: "",
            Nombre: "",
            Materia: "",
            Semestre: "",
            Grupos: "",
            Horas: "",
            F: 1,
          });
        }
      }
      return list;
    },

    cargaAsignadaPorTurno() {
      if (this.carga) {
        let items = this.carga;
        let tm = 0;
        let tv = 0;
        let result = Object.keys(items).map(function (key) {
          if (items[key].docente_id) {
            if (items[key].turno == "TM") tm += parseInt(items[key].horas);
            if (items[key].turno == "TV") tv += parseInt(items[key].horas);
          }
          return items[key];
        });
        return { tm: tm, tv: tv };
      }
      return { tm: 0, tv: 0 };
    },

    cargaNecesidadPorTurno() {
      if (this.carga) {
        let items = this.carga;
        let tm = 0;
        let tv = 0;
        let result = Object.keys(items).map(function (key) {
          if (items[key].docente_id == null) {
            if (items[key].turno == "TM") tm += parseInt(items[key].horas);
            if (items[key].turno == "TV") tv += parseInt(items[key].horas);
          }
          return items[key];
        });
        return { tm: tm, tv: tv };
      }
      return { tm: 0, tv: 0 };
    },

    cargaTotalPorTurno() {
      if (this.carga) {
        let items = this.carga;
        let tm = 0;
        let tv = 0;
        let result = Object.keys(items).map(function (key) {
          if (items[key].turno == "TM") tm += parseInt(items[key].horas);
          if (items[key].turno == "TV") tv += parseInt(items[key].horas);
          return items[key];
        });
        return { tm: tm, tv: tv };
      }
      return { tm: 0, tv: 0 };
    },
  },

  watch: {
    periodoSeleccionado() {
      this.set();
    },
  },

  methods: {
    async set() {
      this.loading = true;
      if (this.periodoSeleccionado == "proximo-periodo") {
        this.periodoActual = false;
      } else if (this.periodoSeleccionado == "periodo-actual") {
        this.periodoActual = true;
      }
      this.periodo = await this.get(
        "periodos",
        this.periodoActual ? "actual" : "proximo"
      );
      this.docentes = await this.get("docentes", "all", "apellidos, nombre");
      this.carga = await this.get("cargas", { id: this.periodo.id });
      this.tutorias = await this.get("tutorias", { id: this.periodo.id });
      this.loading = false;
    },
  },

  mounted() {
    this.$store.commit("setPageTitle", "Carga Académica");
    this.set();
  },
};
</script>

<style>
.border-bottom {
  border-bottom: 1px solid darkgray;
}
.border-top {
  border-top: 1px solid darkgray;
}
</style>